module.exports = __webpack_public_path__ + "static/img/id_back.7df0bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_back.png
// module id = D5t7
// module chunks = 1